export type ModalSizeType = ModalSizeEnum.small | ModalSizeEnum.medium | ModalSizeEnum.full;

export enum ModalSizeEnum {
    small = 'emds-modal-small',
    medium = 'emds-modal-medium',
    full = 'emds-modal-full'
}
